import { Component, OnDestroy, OnInit, input } from '@angular/core';
import { ChatbotConfig } from '@shared/index';
import { SubscriptionLike } from 'rxjs';
import { TypeWriter } from './Typewriter';

@Component({
  selector: 'app-thinking-animation',
  templateUrl: './thinking-animation.component.html',
  styleUrls: ['./thinking-animation.component.scss'],
  imports: []
})
export class ThinkingAnimationComponent implements OnDestroy, OnInit {
  public botConfig = input.required<ChatbotConfig>();
  public message = input('');
  public typeWriter: TypeWriter = new TypeWriter({ characterMillies: 80, clearOnFinish: false });
  public subscription?: SubscriptionLike;

  public newQuote() {
    const q = this.getRandomQuote();
    this.typeWriter.targetStr = q;
  }

  public ngOnInit(): void {
    this.newQuote();
    this.subscription = this.typeWriter.onFinish.subscribe(() => {
      this.newQuote();
    });
  }

  public ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.typeWriter.destroy();
  }

  public getRandomQuote(): string {
    if (this.botConfig().loadingMessages) {
      const quotes = this.botConfig().loadingMessages!.split('\n');
      if (quotes.length > 0) {
        const randomIndex = Math.floor(Math.random() * quotes.length);
        return quotes[randomIndex] + "";
      }
    }
    return "";
  }
}